<template>
  <div>
    <div class="visa_line">
      <a
        @click="$pushByName('visaRouteInfo',{route_id:item.route_id})"
        href="javascript:void(0)"
        v-if="item"
      >
        <div class="visa_line_img">
          <img-lazy :default_src="visa_img" :src="item.img_url"/>
          <!-- <img v-lazy="item.img_url ? item.img_url : visa_img" alt="" :src="item.img_url ? item.img_url : visa_img"> -->
        </div>
      </a>
      <div class="visa_line_right">
        <div class="visa_right_title">
          <a
            @click="$pushByName('visaRouteInfo',{route_id:item.route_id})"
            href="javascript:void(0)"
            v-if="item"
          >
            <p>{{item.route_name}}</p>
          </a>
          <!-- <i>{{item.reference_price | currencyAndToFixed(0)}}</i> -->
        </div>
        <div class="visa_right_line">
          <p>
            <em>办理周期：</em>
            使领馆收齐资料后的 {{speciality.process_cycle}} 个工作日
          </p>
          <p>
            <em>面试：</em>
            {{speciality.interview}}(领馆保留面试权利)
          </p>
          <p>
            <em>有效期：</em>
            {{speciality.date_of_expiry}}
            {{speciality.date_of_expiry_unit}}
            <span
              v-if="speciality.date_of_expiry_remark != ''"
            >({{speciality.date_of_expiry_remark}})</span>
          </p>
          <p>
            <em>可停留天数：</em>
            {{speciality.duration_of_stay}}{{speciality.duration_of_stay_unit}}
          </p>
          <p>
            <em>入境次数：</em>
            {{speciality.entries}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a
              @click="$pushByName('visaRouteInfo',{route_id:item.route_id})"
              href="javascript:void(0)"
              v-if="item"
            >更多></a>
          </p>
          <div class="check">
            <span>
              <em>
                <i>￥</i>
                {{item.reference_price }}
              </em>起
            </span>
            <a
              @click="$pushByName('visaRouteInfo',{route_id:item.route_id})"
              href="javascript:void(0)"
              style="color: #fff; font-size: 1.5em;"
              v-if="item"
            >查看详情</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import visa_img from '@/assets/images/html/visit_05.png'
export default {
  name: 'VisaRouteItem',
  componentName: 'VisaRouteItem',
  data () {
    return {
      visa_img: visa_img,
      speciality: {},
    }
  },
  props: {
    item: {
      type: null,
      default: false
    },
  },
  created () {
    if (this.item && this.item.extend_info) {
      this.speciality = JSON.parse(this.item.extend_info).speciality
    }
  },
  computed: {
  }
}
</script>
<style scoped>
@import '../../assets/css/pages/html/three.css';
</style>



// WEBPACK FOOTER //
// src/pages/common/visaRouteItem.vue